import { classNames } from '@panwds/tailwindcss';
import { endOfDay, format, isAfter, isBefore, isSameDay, isSameMonth, isToday, isWithinInterval, startOfDay } from 'date-fns';
import React from 'react';
function getDateRange({ activeDate, endDate, hoverDate, startDate }) {
    if (!startDate)
        return null;
    if (endDate) {
        return { start: startDate, end: endDate };
    }
    if (hoverDate && isAfter(hoverDate, startDate)) {
        return { start: startDate, end: hoverDate };
    }
    if (hoverDate && isBefore(hoverDate, startDate)) {
        return { start: hoverDate, end: startDate };
    }
    if (activeDate && isAfter(activeDate, startDate)) {
        return { start: startDate, end: activeDate };
    }
    if (activeDate && isBefore(activeDate, startDate)) {
        return { start: activeDate, end: startDate };
    }
    /* istanbul ignore next unreachable, but required for typeing */
    return null;
}
export function Day({ activeDate, day, hoverDate, index, max, min, onHoverDateChange, onSelectedDateChange, selectedDate, dateRange = {} }) {
    const { end: endDate, start: startDate } = dateRange;
    const isActive = isSameDay(activeDate, day);
    const isSelected = !!selectedDate && isSameDay(selectedDate, day);
    const isEndDate = !!endDate && isSameDay(endDate, day);
    const isHoverDate = !!hoverDate && isSameDay(hoverDate, day);
    const isStartDate = !!startDate && isSameDay(startDate, day);
    const isCurrentMonth = isSameMonth(activeDate, day);
    const isDisabled = (min && isBefore(day, startOfDay(min))) || (max && isAfter(day, endOfDay(max)));
    const interval = getDateRange({
        activeDate,
        endDate,
        hoverDate,
        startDate
    });
    const insideRange = interval && isWithinInterval(day, interval);
    const isIntervalEndDate = !!interval?.end && isSameDay(interval.end, day);
    const isIntervalStartDate = !!interval?.start && isSameDay(interval.start, day);
    const className = classNames('tw-relative tw-w-8 tw-h-8', 'tw-text-xs tw-leading-5', 'tw-border-0 tw-rounded-full focus:tw-ring focus:tw-outline-none', isDisabled
        ? 'tw-cursor-not-allowed tw-text-disabled tw-bg-transparent'
        : 'dark:focus:tw-bg-blue-600 hover:tw-bg-blue-100 dark:hover:tw-text-gray-300 dark:hover:tw-bg-gray-800', !isDisabled &&
        (isSelected || isEndDate || isStartDate
            ? 'tw-text-white tw-bg-blue-600 active:tw-bg-blue-800 focus:tw-bg-blue-600 hover:tw-bg-blue-700 dark:hover:tw-text-white'
            : isCurrentMonth
                ? 'tw-text-primary dark:tw-text-white tw-bg-transparent focus:tw-bg-blue-100'
                : 'tw-text-secondary dark:tw-text-dark-bg-secondary tw-bg-transparent focus:tw-bg-blue-100'));
    const date = format(day, 'd');
    return (React.createElement("div", { role: "cell", className: classNames(index !== 0 && insideRange && !isIntervalStartDate ? 'tw-pl-2' : 'tw-ml-2', index === 0 && 'tw-rounded-l-full', index === 6 && 'tw-rounded-r-full', isIntervalStartDate && 'tw-rounded-l-full', isIntervalEndDate && 'tw-rounded-r-full', !interval?.end && isHoverDate && 'tw-rounded-r-full', (insideRange || isIntervalStartDate || isIntervalEndDate) && 'tw-bg-blue-200 dark:tw-bg-blue-400') },
        React.createElement("button", { type: "button", "aria-hidden": isCurrentMonth ? undefined : true, "aria-selected": isSelected || isEndDate || isStartDate, className: className, "data-autofocus": isActive ? true : undefined, "data-date": isCurrentMonth ? date : undefined, "data-testid": isCurrentMonth ? date : undefined, disabled: isDisabled, onClick: () => {
                onSelectedDateChange(day);
            }, onMouseEnter: () => {
                onHoverDateChange?.(day);
            }, tabIndex: isActive ? 0 : -1 },
            date,
            isToday(day) && (React.createElement("span", { className: classNames('tw-absolute tw-w-2 tw-left-3 tw-bottom-1 tw-border tw-border-solid tw-rounded-full', isSelected || isEndDate || isStartDate ? 'tw-border-white' : 'tw-border-blue-600'), "data-testid": "today" })))));
}
//# sourceMappingURL=Day.js.map